import React, { useEffect } from "react";

import Cover from "../components/cover";

import PageAnimationHandler from "../ui-components/animations/page-animation-handler";
import {
	GigaTitle,
	LargeHeading,
	MediumTitle,
	SmallHeading,
} from "../ui-components/texts";
import {
	Column,
	Container,
	ContainerBlock,
} from "../ui-components/columns/components";
import { ScrollXImages } from "../ui-components/force-scroll-x";

import imageTopCover from "../media/images/talent-sourcing-page/1.jpg";
import imageBottomCover from "../media/images/talent-sourcing-page/2.jpg";
import imageContent2 from "../media/images/talent-sourcing-page/4.jpg";
import imageContent3 from "../media/images/talent-sourcing-page/5.jpg";
import imageContent4 from "../media/images/talent-sourcing-page/6.jpg";
import imageContent5 from "../media/images/talent-sourcing-page/8.jpg";
import { useTranslate } from "../contexts/translate";
import { any } from "prop-types";

const TalentSourcing = ({ setNextPageHref, setNextPageName }) => {
	const { translations } = useTranslate();

	useEffect(() => {
		setNextPageHref("/careers");
		setNextPageName(
			translations === null ? "" : translations.navbar.links.careers
		);

		document.title = 'Talent Sourcing - Cutting Edge Digital Creative Studio'
	}, [translations]);

	const imagesScrollX = [
		{
			src: require("../media/images/talent-sourcing-page/slide-1.jpg").default,
		},
		{
			src: require("../media/images/talent-sourcing-page/slide-2.jpg").default,
		},
		{
			src: require("../media/images/talent-sourcing-page/slide-3.png").default,
		},
		{
			src: require("../media/images/talent-sourcing-page/slide-4.png").default,
		},
	];

	return (
		<section className="talent-sourcing-page-component">
			<Cover
				classNameImage2="left-45"
				imageTop={imageTopCover}
				imageBottom={imageBottomCover}
			>
				<GigaTitle className="min-line-height">
					<span className="text-animation animation-delay-05s animation-delay-05s">
						Your partner
					</span>
					<span className="text-animation animation-delay-05s animation-delay-05s">
						in talent
					</span>
				</GigaTitle>
			</Cover>

			<section className="overflow-hidden theme-light light-section mid-padding">
				<ContainerBlock className="fluid">
					<LargeHeading className="mb-5">
						{translations === null ? "" : translations.talentSourcing.section1}
					</LargeHeading>
					<LargeHeading>
						{translations === null ? "" : translations.talentSourcing.section2}
					</LargeHeading>

					<ScrollXImages className="mid-padding pb-0 dark-section" items={imagesScrollX} />
				</ContainerBlock>
			</section>

			<section className="theme-light light-section small-padding pt-0">
				<Container>
					<div className="wrapper fluid">
						<Column className="d-flex flex-column w-50">
							<MediumTitle className="mb-4">
								{translations === null
									? ""
									: translations.talentSourcing.section3.title}
							</MediumTitle>
							<img src={imageContent3} alt="Image content 2" className="mt-auto" />
						</Column>
						<Column className="d-flex flex-column w-50">
							<SmallHeading className="small-text-laptop">
								{translations === null
									? ""
									: translations.talentSourcing.section3.descriptions[0]}
							</SmallHeading>
							<SmallHeading className="mb-4 small-text-laptop">
								{translations === null
									? ""
									: translations.talentSourcing.section3.descriptions[1]}
							</SmallHeading>
							<img
								src={imageContent2}
								alt="Image content 3"
								className="mt-auto"
							/>
						</Column>
					</div>
				</Container>
			</section>

			<section className="theme-light grey-section mid-padding">
				<Container>
					<div className="wrapper fluid">
						<Column className="d-flex flex-column w-50">
							<MediumTitle className="mb-4">
								{translations === null
									? ""
									: translations.talentSourcing.section4.title}
							</MediumTitle>
							<img src={imageContent5} alt="Image content 4" className="mt-auto" />
						</Column>
						<Column className="d-flex flex-column w-50">
							<SmallHeading className="mb-4 small-text-laptop">
								{translations === null
									? ""
									: translations.talentSourcing.section4.descriptions[0]}
							</SmallHeading>
							<img
								src={imageContent4}
								alt="Image content 5"
								className="mt-auto"
							/>
						</Column>
					</div>
			<div className="cta-single-project">
						<div className="cta-single-project-inner">
							<p>{translations && translations.ctaapproach.text}</p>
							<button
								className="leadconnector-button"
								onClick={() => {
									const overlay = document.createElement('div');
									overlay.style.cssText = `
										position: fixed;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
										background-color: rgba(0, 0, 0, 0.7);
										backdrop-filter: blur(5px);
										z-index: 9998;
									`;
									
									const modal = document.createElement('div');
									modal.style.cssText = `
										position: fixed;
										top: 0;
										left: 0;
										width: 100%;
										height: 100%;
										z-index: 9999;
									`;
									
									const closeBtn = document.createElement('button');
									closeBtn.innerHTML = '✕';
									closeBtn.style.cssText = `
										position: fixed;
										top: 30px;
										right: 30px;
										width: 50px;
										height: 50px;
										border: none;
										background-color: rgba(255, 255, 255, 0.2);
										color: white;
										border-radius: 50%;
										cursor: pointer;
										font-size: 28px;
										z-index: 10000;
										transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
										backdrop-filter: blur(10px);
										border: 1px solid rgba(255, 255, 255, 0.3);
										display: flex;
										align-items: center;
										justify-content: center;
									`;
									closeBtn.onmouseover = () => {
										closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.3)';
										closeBtn.style.transform = 'scale(1.15) rotate(90deg)';
										closeBtn.style.boxShadow = '0 8px 32px rgba(0, 0, 0, 0.3)';
										closeBtn.style.borderColor = 'rgba(255, 255, 255, 0.5)';
									};
									closeBtn.onmouseout = () => {
										closeBtn.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
										closeBtn.style.transform = 'scale(1) rotate(0deg)';
										closeBtn.style.boxShadow = 'none';
										closeBtn.style.borderColor = 'rgba(255, 255, 255, 0.3)';
									};
									closeBtn.onclick = () => {
										overlay.style.opacity = '0';
										modal.style.opacity = '0';
										overlay.style.transition = 'opacity 0.4s ease-out';
										modal.style.transition = 'opacity 0.4s ease-out';
										setTimeout(() => {
											document.body.removeChild(overlay);
											document.body.removeChild(modal);
										}, 400);
									};
									
									const iframe = document.createElement('iframe');
									iframe.src = 'https://api.leadconnectorhq.com/widget/survey/nnm8iIalh5UEBSaSELLQ';
									iframe.style.cssText = `
										width: 100%;
										height: 100%;
										border: none;
									`;
									iframe.allowFullscreen = true;
									
									modal.appendChild(iframe);
									modal.appendChild(closeBtn);
									document.body.appendChild(overlay);
									document.body.appendChild(modal);
									
									overlay.onclick = () => {
										document.body.removeChild(overlay);
										document.body.removeChild(modal);
									};
								}}
							>
								{translations && translations.ctaapproach.button}
							</button>
						</div>
					</div>
				</Container>
			</section>
		</section>
	);
};

TalentSourcing.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default TalentSourcing;
